var React = require('react');

function IconDashSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M162.727 156.955l-29.408-29.408c9.065-10.35 14.561-23.912 14.561-38.758 0-10.992-2.998-21.271-8.28-30.122-2.07-3.426-6.781-3.997-9.636-1.142-1.999 1.999-2.427 5.068-.999 7.423 4.283 7.209 6.638 15.56 6.495 24.554-.428 25.696-21.056 45.967-46.753 45.967-25.767 0-46.753-20.985-46.753-46.753.071-25.625 20.486-46.324 46.182-46.61 8.994-.143 17.416 2.355 24.625 6.638 2.427 1.428 5.496.999 7.495-.928 2.855-2.855 2.284-7.566-1.142-9.636-9.351-5.639-20.343-8.78-32.12-8.423-30.549.859-55.674 25.342-57.244 55.891-1.784 34.047 25.411 62.313 59.03 62.313 12.348 0 23.769-3.783 33.262-10.278l29.979 29.979c2.141 2.141 5.71 2.141 7.923 0l2.784-2.784c2.141-2.141 2.141-5.71-.001-7.923z"}));
}

IconDashSearch.displayName = "IconDashSearch";

IconDashSearch.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconDashSearch;

IconDashSearch.default = IconDashSearch;
